import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/very-satisfied-filled.vue
var o = {
	name: "DtIconVerySatisfiedFilled",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--very-satisfied-filled"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Very Satisfied Filled",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M11.438 6A5.437 5.437 0 1 0 .563 6a5.437 5.437 0 0 0 10.874 0Zm-3.5-1.5a.438.438 0 0 0-.438-.438h-.005a.437.437 0 1 0 0 .875H7.5a.437.437 0 0 0 .438-.437Zm-3 0a.438.438 0 0 0-.438-.438h-.005a.437.437 0 1 0 0 .875H4.5a.437.437 0 0 0 .438-.437Zm4.396 1.718A.437.437 0 0 0 9 6.063H3a.437.437 0 0 0-.431.51A3.437 3.437 0 0 0 6 9.438a3.437 3.437 0 0 0 3.431-2.865.437.437 0 0 0-.097-.355Zm-.907.72a2.562 2.562 0 0 1-2.42 1.625h-.014a2.562 2.562 0 0 1-2.42-1.626h4.853Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=very-satisfied-filled.js.map